import CatalogWidget from "@/widgets/catalog";

export default function  CatalogPage () {
    return (
        <CatalogWidget />
    )
}